"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = UploadMenu;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const IconOnSteroid_1 = __importDefault(require("../IconOnSteroid"));
const AppText_1 = require("../AppText");
const GradientBorder_1 = __importDefault(require("../ui-components/GradientBorder"));
const UploadInput_1 = __importDefault(require("./UploadInput"));
const colors_1 = require("../../common/colors");
;
function UploadMenu({ handleUploadImages, handleUploadFiles, options, verticalOffset, style }) {
    const [isMenuOpen, setIsMenuOpen] = (0, react_1.useState)(false);
    const menuRef = (0, react_1.useRef)(null);
    const { current: fadeAnimation } = (0, react_1.useRef)(new react_native_1.Animated.Value(0));
    const handleMenuOpen = (0, react_1.useCallback)(() => {
        setIsMenuOpen(true);
        react_native_1.Animated.timing(fadeAnimation, { toValue: 1, duration: 200, useNativeDriver: true });
    }, []);
    const handleMenuClose = (0, react_1.useCallback)(() => {
        setIsMenuOpen(false);
        react_native_1.Animated.timing(fadeAnimation, { toValue: 0, duration: 150, useNativeDriver: true });
    }, []);
    const handleSelectImages = (0, react_1.useCallback)((files) => {
        handleUploadImages?.(files);
        handleMenuClose();
    }, [handleMenuClose, handleUploadImages]);
    const handleSelectFiles = (0, react_1.useCallback)((files) => {
        handleUploadFiles?.(files);
        handleMenuClose();
    }, [handleMenuClose, handleUploadFiles]);
    const Trigger = (0, react_1.useCallback)((triggerProps) => ((0, jsx_runtime_1.jsx)(GradientBorder_1.default, { colors: colors_1.Colors.CTA_GRADIENT_2, width: isMenuOpen ? 2 : 0, radius: 28, children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { style: (pressed) => [
                styles.triggerContainer,
                isMenuOpen && styles.triggerContainerOpen,
                typeof style === 'function' ? style(pressed) : style
            ], ...triggerProps, children: isMenuOpen ? ((0, jsx_runtime_1.jsx)(IconOnSteroid_1.default, { icon: pro_solid_svg_icons_1.faTimes, size: 20, y2: 1 })) : ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlus, color: colors_1.Colors.NEUTRAL_00, size: 20 })) }) })), [isMenuOpen]);
    return ((0, jsx_runtime_1.jsx)(native_base_1.Menu, { ref: menuRef, trigger: Trigger, isOpen: isMenuOpen, onOpen: handleMenuOpen, onClose: handleMenuClose, offset: 14 + (verticalOffset ?? 0), crossOffset: -12, style: styles.normalizedMenu, children: (0, jsx_runtime_1.jsx)(GradientBorder_1.default, { colors: colors_1.Colors.CTA_GRADIENT_2, width: 2, radius: 24, style: styles.menuBorder, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.menuContainer, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.menuTitle, children: "Upload" }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.itensContainer, children: [options?.images !== false && ((0, jsx_runtime_1.jsx)(native_base_1.Menu.Item, { style: styles.normalizedItem, children: (0, jsx_runtime_1.jsx)(UploadInput_1.default, { icon: (0, jsx_runtime_1.jsx)(IconOnSteroid_1.default, { icon: pro_solid_svg_icons_1.faImagePolaroid, gradientColors: colors_1.Colors.CTA_GRADIENT_1, size: 24, y2: 1 }), title: 'Photos', subtitle: 'JPEG, PNG, GIF, WEBP', fileType: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'], fileAction: handleSelectImages }) })), options?.files !== false && ((0, jsx_runtime_1.jsx)(native_base_1.Menu.Item, { style: styles.normalizedItem, children: (0, jsx_runtime_1.jsx)(UploadInput_1.default, { icon: (0, jsx_runtime_1.jsx)(IconOnSteroid_1.default, { icon: pro_solid_svg_icons_1.faFileLines, gradientColors: colors_1.Colors.CTA_GRADIENT_1, size: 24, y2: 1 }), title: 'File', subtitle: 'PDF, TXT, CSV', fileType: ['application/pdf', 'text/plain', 'text/csv'], fileAction: handleSelectFiles }) }))] })] }) }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    triggerContainer: {
        backgroundColor: colors_1.Colors.NEUTRAL_100,
        padding: 14,
        borderRadius: 24,
    },
    triggerContainerOpen: {
        padding: 12,
    },
    menuBorder: {
        shadowColor: 'rgba(0, 0, 0, 0.40)',
        shadowOffset: {
            height: 4,
            width: 4,
        },
        shadowRadius: 24,
    },
    menuContainer: {
        backgroundColor: colors_1.Colors.NEUTRAL_75,
        gap: 12,
        padding: 14,
        borderRadius: 24,
    },
    itensContainer: {
        gap: 4,
    },
    menuTitle: {
        color: colors_1.Colors.NEUTRAL_25,
        lineHeight: 14,
    },
    normalizedMenu: {
        backgroundColor: 'transparent',
        padding: 0,
    },
    normalizedItem: {
        backgroundColor: 'transparent',
        padding: 0,
        marginHorizontal: -12,
    },
});
